import { render, staticRenderFns } from "./employeeInteraction-2.vue?vue&type=template&id=1227398a&scoped=true&"
import script from "./employeeInteraction-2.vue?vue&type=script&lang=js&"
export * from "./employeeInteraction-2.vue?vue&type=script&lang=js&"
import style0 from "./employeeInteraction-2.vue?vue&type=style&index=0&id=1227398a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227398a",
  null
  
)

export default component.exports